import { z } from 'zod';
import { entityRefSchema } from './refs.js';

export const EVENT_TYPES = [
  'core.person.changed.v1',
  'library.book.changed.v1',
  'library.book.deleted.v1',
  'library.reading.recorded.v1',
  'library.note.changed.v1',
  'mind.entity.changed.v1',
] as const;

export const eventEnvelopeSchema = z.object({
  eventId: z.string(),
  workspaceId: z.string(),
  actorId: z.string(),
  type: z.string().regex(/^[a-z-]+\.[a-z.]+\.v\d+$/),
  schemaVersion: z.number().int().positive(),
  moduleId: z.string(),
  aggregateRef: entityRefSchema,
  aggregateRevision: z.number().int().min(0),
  occurredAt: z.string(),
  correlationId: z.string(),
  payload: z.record(z.string(), z.unknown()),
});
export type EventEnvelope = z.infer<typeof eventEnvelopeSchema>;
